import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: '#f9fafb',
        minHeight: '100vh',
        fontFamily: 'Inter, sans-serif',
        paddingTop: '12px',
    },
    appBar: {
        backgroundColor: 'white',
        color: '#173300',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        position: 'sticky',
        top: '12px',
        zIndex: 1,
    },
    toolbar: {
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    headerLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        textDecoration: 'none',
    },
    breadcrumb: {
        color: '#4A4A4A',
        fontSize: '14px',
    },
    title: {
        fontWeight: 600,
        fontSize: '18px',
        color: '#173300',
    },
    editButton: {
        color: '#173300',
        fontSize: '14px',
        fontWeight: 500,
    },
    statusContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(1.5),
    },
    statusChips: {
        display: 'flex',
        gap: '8px',
    },
    paidChip: {
        backgroundColor: '#dcfce7',
        color: '#166534',
        fontSize: '12px',
        fontWeight: 500,
    },
    notPreparedChip: {
        backgroundColor: '#fed7aa',
        color: '#9a3412',
        fontSize: '12px',
        fontWeight: 500,
    },
    mainContent: {
        padding: theme.spacing(2),
        paddingBottom: theme.spacing(12),
        gap: theme.spacing(1.5),
        display: 'flex',
        flexDirection: 'column',
    },
    section: {
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: theme.spacing(2),
        boxShadow: 'none',
        border: 'none',
    },
    sectionTitle: {
        color: '#173300',
        fontWeight: 600,
        fontSize: '16px',
        marginBottom: theme.spacing(1.5),
    },
    ctaButton: {
        backgroundColor: '#9EE870',
        color: 'white',
        fontWeight: 500,
        width: '100%',
        padding: theme.spacing(1.5),
        borderRadius: '8px',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#8dd85f',
        },
    },
    whatsappButton: {
        backgroundColor: '#f0fdf4',
        color: '#166534',
        fontWeight: 500,
        width: '100%',
        padding: theme.spacing(1.5),
        borderRadius: '8px',
        textTransform: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        '&:hover': {
            backgroundColor: '#dcfce7',
        },
        textDecoration: 'none'
    },
    paymentAlert: {
        backgroundColor: '#fef2f2',
        color: '#991b1b',
        border: '1px solid #fecaca',
        borderRadius: '8px',
        marginBottom: theme.spacing(2),
    },
    infoRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(1.5),
        '&:last-child': {
            marginBottom: 0,
        },
    },
    infoLabel: {
        color: '#4A4A4A',
        fontSize: '14px',
    },
    infoValue: {
        color: '#173300',
        fontSize: '14px',
        fontWeight: 500,
    },
    addressValue: {
        color: '#173300',
        fontSize: '14px',
        textAlign: 'right',
        lineHeight: 1.4,
    },
    divider: {
        borderTop: '1px solid #e5e7eb',
        margin: theme.spacing(2, 0),
    },
    orderMeta: {
        marginBottom: theme.spacing(2),
    },
    orderDate: {
        color: '#4A4A4A',
        fontSize: '14px',
        marginBottom: theme.spacing(0.5),
    },
    salesChannel: {
        fontSize: '14px',
        '& a': {
            color: '#2563eb',
            textDecoration: 'underline',
        },
    },
    productTable: {
        '& .MuiTableCell-root': {
            padding: theme.spacing(1.5, 1),
            fontSize: '12px',
            borderBottom: '1px solid #f3f4f6',
        },
        '& .MuiTableHead-root .MuiTableCell-root': {
            color: '#4A4A4A',
            fontWeight: 500,
            padding: theme.spacing(1, 1),
        },
    },
    productRow: {
        '& .MuiTableCell-root': {
            borderBottom: '1px solid #f3f4f6',
        },
    },
    productInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    productImage: {
        width: 32,
        height: 32,
        backgroundColor: '#e5e7eb',
        borderRadius: 4,
    },
    productDetails: {
        '& .product-name': {
            color: '#173300',
            fontSize: '12px',
            fontWeight: 500,
            marginBottom: 2,
        },
        '& .product-variant': {
            color: '#4A4A4A',
            fontSize: '12px',
            marginBottom: 1,
        },
        '& .product-sku': {
            color: '#4A4A4A',
            fontSize: '12px',
        },
    },
    totalSection: {
        borderTop: '1px solid #e5e7eb',
        paddingTop: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    totalRow: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(1),
        '&.total-final': {
            fontWeight: 600,
            fontSize: '16px',
            borderTop: '1px solid #e5e7eb',
            paddingTop: theme.spacing(1),
            marginTop: theme.spacing(1),
        },
    },
    commentsBox: {
        backgroundColor: '#f9fafb',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        padding: theme.spacing(1.5),
        fontStyle: 'italic',
        color: '#4A4A4A',
        fontSize: '14px',
    },
}));

export default useStyles;
